import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 220,
      sortable: true,
    },
    {
      prop: 'unit',
      label: i18n.t('common_words.unit'),
      align: 'center',
      sortable: true,
      minWidth: 160,
    },
  ];

  return { tableColumns };
};

export default configTable;
